import AmbassadorDashboard from "./dashboard";
import CreateAccount from "./createAccount";

export default [AmbassadorDashboard, CreateAccount];
